"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runCodeHere = runCodeHere;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

function runCodeHere(el, code) {
  if (!el) return; // Compatibility with Jupyter/notebook JS evaluation.  Set element so
  // the user has a handle on the context of the current output.

  var element = el;

  try {
    return eval(code); // eslint-disable-line no-eval
  } catch (err) {
    var pre = document.createElement("pre");

    if (err.stack) {
      pre.textContent = err.stack;
    } else {
      pre.textContent = err;
    }

    element.appendChild(pre);
    return err;
  }
}

var JavaScript = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(JavaScript, _React$Component);

  function JavaScript() {
    (0, _classCallCheck2["default"])(this, JavaScript);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(JavaScript).apply(this, arguments));
  }

  (0, _createClass2["default"])(JavaScript, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      runCodeHere(this.el, this.props.data);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.data !== this.props.data;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      runCodeHere(this.el, this.props.data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react["default"].createElement("div", {
        ref: function ref(el) {
          _this.el = el;
        }
      });
    }
  }], [{
    key: "handles",
    value: function handles(mimetype) {
      return mimetype.startsWith("text/") || mimetype.startsWith("application/javascript") || mimetype.startsWith("application/json");
    }
  }]);
  return JavaScript;
}(_react["default"].Component);

exports["default"] = JavaScript;
(0, _defineProperty2["default"])(JavaScript, "MIMETYPE", "application/javascript");